import React, {useEffect} from 'react';
import {get, filter, mean, map} from 'lodash';
import Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
HC_more(Highcharts);

export default function ({skills}) {

    const graph_id = 'skills-passport-achievement-overview-graph';

    useEffect(() => {
        if (skills) {
            draw();
        }
    }, [skills]);

    // Compute graph data
    const categories = map(skills, (s) => `${s.practice_skill_name}`);
    const data = map(skills, (s) => s.achievement_percentage);
    while (categories.length < 6) {
        categories.push('-');
        data.push(50);
    }

    function draw() {
        const graph = {
            chart: {
                polar: true,
                type: 'line',
                height: 300
            },
            title: null,
            // title: {
            //     text: 'Student Achievement',
            //     style: {
            //         fontWeight: 'bolder',
            //         fontSize: '18px'
            //     }
            // },
            pane: {
                // size: '80%'
            },
            xAxis: {
                categories: categories,
                tickmarkPlacement: 'on',
                lineWidth: 0,
                labels: {
                    style: {}
                }
            },
            yAxis: {
                gridLineInterpolation: 'polygon',
                lineWidth: 0,
                min: 0,
                max: 100,
                labels: {
                    enabled: false,
                    format: '{text}%'
                }
            },
            // tooltip: {
            //     pointFormat: '<span>{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
            //     shared: true
            // },
            series: [{
                name: `Skill achievement`,
                data,
                pointPlacement: 'on',
                color: '#74C043'
            }],
            // legend: {
            //     enabled: true,
            //     reversed: true
            // },
            credits: {
                enabled: false
            }
        }

        Highcharts.chart(graph_id, graph)
    }

    if (skills === undefined) {
        return null;
    }

    return (
        <div>
            <div id={graph_id} />
        </div>
    );
}
